import { Injectable } from "@angular/core";
import { CanActivate, CanActivateChild, Router } from "@angular/router";
import { AuthService } from "../../services/auth/auth.service";

@Injectable()
export class PhysicianPortalAccessGuard
  implements CanActivate, CanActivateChild {
  constructor(private router: Router, private authService: AuthService) {}

  canActivate() {
    let user = this.authService.getUser();
    const roles = ["physician", "assistant", "delegate", "admin", "superadmin"];
    if (user && roles.includes(user.Role)) {
      return true;
    }

    this.router.navigate(["/no-access"]);
    return false;
  }

  canActivateChild() {
    return this.canActivate();
  }
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/guard/physician-portal/physician-portal-access.guard.ts